import React from 'react';
import { RefreshCcw, DollarSign, Clock, AlertCircle } from 'lucide-react';

export const RefundPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-400 to-red-500 p-8 md:p-12 text-white text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <RefreshCcw className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-extrabold mb-4">Kebijakan Refund</h1>
            <p className="text-orange-50 max-w-xl mx-auto">
              Informasi mengenai pengembalian dana dan pembatalan pesanan tiket Anda.
            </p>
          </div>

          <div className="p-8 md:p-12">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="text-center p-6 bg-orange-50 rounded-2xl border border-orange-100">
                <Clock className="w-8 h-8 text-orange-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Batas Waktu</h3>
                <p className="text-sm text-gray-600">Pengajuan maksimal 24 jam sebelum tanggal kunjungan.</p>
              </div>
              <div className="text-center p-6 bg-blue-50 rounded-2xl border border-blue-100">
                <DollarSign className="w-8 h-8 text-blue-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Biaya Admin</h3>
                <p className="text-sm text-gray-600">Potongan biaya administrasi sebesar 10% dari total harga.</p>
              </div>
              <div className="text-center p-6 bg-green-50 rounded-2xl border border-green-100">
                <RefreshCcw className="w-8 h-8 text-green-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Proses</h3>
                <p className="text-sm text-gray-600">Pengembalian dana diproses dalam 3-7 hari kerja.</p>
              </div>
            </div>

            <div className="space-y-8">
              <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <AlertCircle className="w-5 h-5 text-orange-600" /> Syarat Pengajuan Refund
                </h2>
                <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 text-gray-600 leading-relaxed">
                  <ul className="list-disc pl-5 space-y-3">
                    <li>Hanya tiket dengan kategori tertentu yang dapat direfund (lihat detail pada jenis tiket saat pembelian).</li>
                    <li>Tiket promo atau tiket dengan harga diskon khusus umumnya bersifat non-refundable (tidak dapat diuangkan kembali).</li>
                    <li>Tiket yang sudah melewati tanggal kunjungan atau sudah digunakan tidak dapat direfund.</li>
                    <li>Refund harus diajukan oleh pemesan asli menggunakan alamat email yang terdaftar saat pembelian.</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4">Cara Mengajukan Refund</h2>
                <div className="prose prose-indigo text-gray-600 max-w-none">
                  <p>Untuk mengajukan pengembalian dana, silakan ikuti langkah-langkah berikut:</p>
                  <ol className="list-decimal pl-5 space-y-4 font-medium">
                    <li>Kirim email ke <span className="text-giz-primary">support@surabayaticket.id</span> atau hubungi WhatsApp Customer Service kami.</li>
                    <li>Sertakan Kode Booking dan Detail Alasan pembatalan.</li>
                    <li>Lampirkan bukti pembayaran yang sah.</li>
                    <li>Tunggu tim kami melakukan verifikasi data pesanan Anda.</li>
                    <li>Jika disetujui, dana akan dikirimkan kembali ke rekening/e-wallet asal Anda.</li>
                  </ol>
                </div>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-100 text-center text-sm text-gray-500 italic">
              *Surabaya Ticket berhak menolak pengajuan refund jika ditemukan adanya penyalahgunaan atau ketidaksesuaian data.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
